import { Aux } from './AuxillaryServices';
import { $ } from '../../vendor/jquery';
import _ from 'underscore';

function HeartbeatService() {
    var t = this;

    t.m_QueryPromise = null;
    t.m_Cancel = false;

    this.onDiscoveryComplete = function (enable) {
        if (enable) {
            beginBeating();
        } else {
            suspendBeating();
        }
    };

    function postCache() {
        var promise = $.ajax({
            url: 'https://localhost:8082/Cache/Heartbeat',
            type: 'PUT',
            data: JSON.stringify({
                value: Math.round(Date.now() / 1000),
            }),
            timeout: 3000,
            success: function () {
                setTimeout(onQueryComplete, 1000);
            },
            error: function () {
                //maybe the Cache service was restarted or Heartbeat key was
                //deleted...
                $.ajax({
                    url: 'https://localhost:8082/Cache/Heartbeat',
                    type: 'POST',
                    data: JSON.stringify({
                        value: Math.round(Date.now() / 1000),
                    }),
                    timeout: 3000,
                    success: function () {
                        setTimeout(onQueryComplete, 1000);
                    },
                    error: function () {
                        setTimeout(onQueryComplete, 1000);
                    },
                });
            },
        });

        return promise;
    }

    function onQueryComplete() {
        t.m_QueryPromise = null;

        if (!t.m_Cancel) {
            t.m_QueryPromise = postCache();
        }
    }

    function beginBeating() {
        if (null === t.m_QueryPromise) {
            t.m_Cancel = false;

            $.ajax({
                url: 'https://localhost:8082/Cache/Heartbeat',
                type: 'POST',
                data: JSON.stringify({
                    value: Math.round(Date.now() / 1000),
                }),
                timeout: 3000,
                success: function () {
                    setTimeout(onQueryComplete, 1000);
                },
                error: function () {
                    setTimeout(onQueryComplete, 1000);
                },
            });
        }
    }

    function suspendBeating() {
        t.m_Cancel = true;
    }
}

function HeartbeatBase() {}

HeartbeatBase.m_Loaded = false;
HeartbeatBase.Mechanism = null;

HeartbeatBase.onServiceDiscovered = function (event, param) {
    switch (event) {
        case 'Initialize': {
            if (!HeartbeatBase.Mechanism) {
                HeartbeatBase.Mechanism = new HeartbeatService();

                Aux.RegisterService('Heartbeat', HeartbeatBase.Mechanism);
            }

            break;
        }
        case 'ServicesDiscovered': {
            if (_.contains(param, 'REACH.Cache')) {
                HeartbeatBase.Mechanism.onDiscoveryComplete(true);
            }

            break;
        }
        case 'DiscoveryFailed': {
            HeartbeatBase.Mechanism.onDiscoveryComplete(false);

            break;
        }
    }
};

/**
 * @todo document this
 */
function initializeHeartbeat() {
    Aux.AddListener(HeartbeatBase.onServiceDiscovered);
}

export { initializeHeartbeat };
